export default "__VITE_ASSET__C5aLHwA8__"